import React, { useEffect, useState } from 'react'
import { IClinique } from 'components/core/types'
import TimeIcon from 'assets/images/icon-open.svg'
import { useTranslation } from 'react-i18next'
import { getCliniqueOpenCloseDetails } from 'components/core/state/selectors'

interface OpenClosedProps {
  clinique: IClinique,
}

const OpenClosed = ({ clinique }: OpenClosedProps) => {
  const { t } = useTranslation()

  const {
    status,
    className,
    nextStatus,
    nextStatusChangeHour,
  } = getCliniqueOpenCloseDetails(clinique)
  const newLabel = t(status ? 'open' : 'closed')
  const opacityClass = status ? 'opacity-100' : 'opacity-50'

  const [isOpen, setIsOpen] = useState(status)
  const [tick, setTick] = useState(null)
  useEffect(() => {
    setTick(setInterval(() => {
      const { status: newStatus } = getCliniqueOpenCloseDetails(clinique)
      setIsOpen(newStatus)
    }, 60000))
    return () => {
      clearInterval(tick)
    }
  }, [isOpen])

  return (
    <div className={`tw-flex tw-items-center ${opacityClass}`}>
      <img src={TimeIcon} alt="open-close-status" />
      <span className={`tw-ml-2 tw-text-lg tw-font-extrabold tw-uppercase tw-tracking-widest ${className}`}>
        {newLabel}
        {' '}
        {nextStatusChangeHour
          ? (
            <span className="tw-text-xs">
              {t(nextStatus)}
              {' '}
              {nextStatusChangeHour}
            </span>
          )
          : null}
      </span>
    </div>
  )
}
export default OpenClosed
